<template>
<div>
	<!-- ✅ Show Gmail One Click widget only if Pro is NOT active -->
	<post-smtp-widget v-if="!postSmtpPro" class="gmail-wrapper">
		<div class="img-wrapper">
			<a class="gmail-click" target="_blank" href="https://postmansmtp.com/pricing/?utm_source=plugin&utm_medium=dashboard&utm_campaign=gmail_one_click">
		<post-smtp-img class="gmail-one-click" :src="plugin_dir_url + 'assets/images/gmail_one_click.gif'" />
			</a>
		</div>
	</post-smtp-widget>

	<!-- ✅ Show Office One Click widget only if Professional or Basic plan is active -->
	<post-smtp-widget v-if="isProfessionalOrBasic" class="office-wrapper">
		<div class="img-wrapper">
			<a class="office-click" target="_blank" href="https://postmansmtp.com/pricing/">
				<post-smtp-img class="office-one-click" :src="plugin_dir_url + 'assets/images/office_oneclick.gif'" />
			</a>
		</div>
	</post-smtp-widget>

	<!-- ✅ Show Ads only if Pro is active and configured -->
	<post-smtp-ads
		v-if="postSmtpPro && postSmtpConfigured"
		class="mb-24"
		:post-smtp-pro="postSmtpPro"
		:is-mobile-app-configured="isMobileAppConfigured"
		:is-main-wp-configured="isMainWpConfigured"
		:is-domain-spam-score-configured="isDomainSpamScoreConfigured"
	/>

	<!-- ✅ Always show Troubleshooting widget -->
	<post-smtp-widget class="troubleshooting">
		<div class="troubleshooting-header">
			{{ i18n.titleTroubleshooting }}
		</div>
		<div class="troubleshooting-content">
			<ul>
				<li v-for="troubleshoot in troubleshooting" class="troubleshoot">
					<div v-if="troubleshoot.show">
						<span v-if="!troubleshoot.image" style="margin-right: 15px; color: #3c5daa;" :class="troubleshoot.icon"></span>
						<img v-if="troubleshoot.image" style="margin-bottom: -5px; margin-right: 16px;" :src="plugin_dir_url + 'assets/images/' + troubleshoot.icon" />
						<a :target="troubleshoot.target" :href="troubleshoot.url">
							{{ troubleshoot.title }}
							<span v-if="troubleshoot.target" style="color: #8B8F9A; font-size: 15px; margin-left: -3px;" class="dashicons dashicons-external"></span>
						</a>
					</div>
				</li>
			</ul>
		</div>
	</post-smtp-widget>

	<!-- ✅ Always show Customer Support widget -->
	<post-smtp-widget class="customer-support">
		<div>
			<post-smtp-img :src="plugin_dir_url + 'assets/images/customer-support.png'" />
		</div>
		<div class="customer-support-content">
			<p>
				{{ i18n.appointment.description }}
			</p>
		</div>
		<div>
			<post-smtp-button
				href="https://postmansmtp.com/configuration-request/?utm_source=plugin&utm_medium=dashboard_side_banner&utm_campaign=plugin"
				type="secondary"
			>
				{{ i18n.appointment.button }}
			</post-smtp-button>
		</div>
	</post-smtp-widget>

</div>


</template>

<script>
export default {
	name: 'PostSmtpSidebar',

	props: {
		postSmtpPro: {
			type: Boolean,
			default: false,
		},
		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},

		isMobileAppConfigured: {
			type: Boolean,
			default: false,
		},

		isMainWpConfigured: {
			type: Boolean,
			default: false,
		},

		isDomainSpamScoreConfigured: {
			type: Boolean,
			default: false,
		},

		isProfessionalOrBasic: {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.sidebar,
		troubleshooting: [
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[0],
				icon: 'email.svg',
				url: vm.$parent.admin_url + '?page=postman/email_test',
				image: true,
				target: false,
				show: true,
			},
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[1],
				url: 'https://postmansmtp.com/domain-health-checker/',
				icon: 'dashicons dashicons-performance',
				image: false,
				target: '_blank',
				show: true,
			},
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[2],
				icon: 'import-export.svg',
				url: vm.$parent.admin_url + '?page=postman/manage-options',
				image: true,
				target: false,
				show: true,
			},
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[3],
				icon: 'connectivity.svg',
				url: vm.$parent.admin_url + '?page=postman/port_test',
				image: true,
				target: false,
				show: true,
			},
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[4],
				icon: 'diagnostic.svg',
				url: vm.$parent.admin_url + '?page=postman/diagnostics',
				image: true,
				target: false,
				show: true,
			},
			{
				title: postSmtpNewDashboard.i18n.sidebar.troubleshooting[5],
				icon: 'reset.svg',
				url: vm.$parent.admin_url + '?page=postman/manage-options',
				image: true,
				target: false,
				show: true,
			},
		]
	} ),
}
</script>

<style scoped>

.customer-support {
	padding: 0 !important;
	background: linear-gradient(180deg, #40518E 0%, #231F20 100%);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	height: 268px;
}

.customer-support-content {
	width: 213px;
}

.customer-support-content p {
	font-family: Poppins;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
	color: #B8BDCA;
}

.troubleshooting {
	padding: 0 !important;
}

.mb-24 {
	margin-bottom: 24px;
}

.troubleshooting-header {
	border-radius: 4px 4px 0 0;
	background: #EFF4FD;
	padding: 16px 24px;

	font-family: Poppins;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	color: #231F20;
}


.troubleshooting-content {
	padding: 24px;
}

.troubleshoot.email {
	list-style: url("../images/email.svg") inside;
}

.troubleshoot.import-export {
	list-style: url("../images/import-export.svg") inside;
}

.troubleshoot.connectivity {
	list-style: url("../images/connectivity.svg") inside;
}

.troubleshoot.diagnostic {
	list-style: url("../images/diagnostic.svg") inside;
}

.troubleshoot.reset {
	list-style: url("../images/reset.svg") inside;
}

.troubleshoot a {
	font-family: Poppins;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	color: #8B8F9A;
	text-decoration: underline;
}
</style>